import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import {  publishReplay, refCount } from 'rxjs/operators';
import translate from "translate";

@Injectable({
  providedIn: 'root'
})
export class TranslateService {

  private cache: { [name: string]: Observable<string> } = {};

  constructor() { }

  public translate(template: string, language: string): Observable<string> {
    if (!this.cache[template]) {
      this.cache[template] = from(translate(template, language)).pipe(publishReplay(), refCount());
    }
    return this.cache[template];
  }

}
